export const localStorageUtil = {
    /**
     * Stores a value in localStorage after encoding it in Base64.
     * @param {string} key - The key under which the value is stored.
     * @param {any} value - The value to store. Non-string values are stringified.
     */
    setItem: (key, value) => {
        try {
            const encodedValue = btoa(value);
            localStorage.setItem(key, encodedValue); // Use native localStorage
        } catch (error) {
            console.error('Error setting item in localStorageUtil:', error);
        }
    },

    /**
     * Retrieves a value from localStorage after decoding it from Base64.
     * @param {string} key - The key of the value to retrieve.
     * @returns {any} - The decoded value, or null if not found or an error occurs.
     */
    getItem: (key) => {
        try {
            const encodedItem = localStorage.getItem(key); // Use native localStorage
            if (!encodedItem) return null;
            const decodedValue = atob(encodedItem);
            return decodedValue;
        } catch (error) {
            console.error('Error getting item from localStorageUtil:', error);
            return null;
        }
    },

    /**
     * Removes a value from localStorage.
     * @param {string} key - The key of the value to remove.
     */
    removeItem: (key) => {
        try {
            localStorage.removeItem(key); // Use native localStorage
        } catch (error) {
            console.error('Error removing item from localStorageUtil:', error);
        }
    },

    /**
     * Clears all values from localStorage.
     */
    clear: () => {
        try {
            localStorage.clear(); // Use native localStorage
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }
    }
};